import script from "./Logo.vue?vue&type=script&setup=true&lang=js"
export * from "./Logo.vue?vue&type=script&setup=true&lang=js"

import "./Logo.vue?vue&type=style&index=0&id=3f578af0&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f578af0"]])

export default __exports__